import '../styles/ProgressBar.css'

const ProgressBar = ({ bgcolor = '#7ec5c6', completed = 0, backgroundColor = '#413F5E', height = 7 }) => {
    return (
        <div className="containerStyles" style={{ backgroundColor: backgroundColor }}>
            <div className="fillerStyles" style={{ width: `${Math.min(completed, 100)}%`, backgroundColor: bgcolor }}>
                <div
                    className="labelStyles"
                    style={{ background: `repeating-linear-gradient(-45deg, ${bgcolor}, ${bgcolor} 5px, #ffffff70 5px, #ffffff70 8px)`, height: height, padding: 0 }}
                ></div>
            </div>
        </div>
    )
}

export default ProgressBar
